import * as actionTypes from "./actionTypes";
import axios from "../../axios-orders";
// synchronous actioncreater
export const purchaseBurgerSuccess = (id, orderData) => {
  return {
    type: actionTypes.PURCHASE_BURGER_SUCCESS,
    orderId: id,
    orderData: orderData,
  };
};

export const purchaseBurgerFail = (error) => {
  return {
    type: actionTypes.PURCHASE_BURGER_FAIL,
    error: error,
  };
};

export const purchaseBurgerStart = () => {
  return {
    type: actionTypes.PURCHASE_BURGER_START,
  };
};

//async actionCreators
export const purchaseBurger = (orderData, token) => {
  return (dispatch) => {
    dispatch(purchaseBurgerStart());
    // this below is from orderHandler in contactData.js
    axios
      .post("/orders.json?auth=" + token, orderData)
      .then((response) => {
        //instead of this
        // this.setState({ loading: false });
        // this.props.history.push("/");
        dispatch(purchaseBurgerSuccess(response.data.name, orderData));
      })
      .catch((error) => {
        // this.setState({ loading: false });
        dispatch(purchaseBurgerFail(error));
      });
  };
};

export const purchaseInit = () => {
  // just return an action
  return {
    type: actionTypes.PURCHASE_INIT,
  };
};

export const fetchOrdersSuccess = (orders) => {
  return {
    type: actionTypes.FETCH_ORDERS_SUCCESS,
    orders: orders,
  };
};

export const fetchOrdersFail = (error) => {
  return {
    type: actionTypes.FETCH_ORDERS_FAIL,
    error: error,
  };
};

export const fetchOrdersStart = () => {
  return {
    type: actionTypes.FETCH_ORDERS_START,
  };
};

export const fetchOrders = (token, userId) => {
  // got the axios code from containers->orders.js , componentDidMount
  return (dispatch) => {
    dispatch(fetchOrdersStart());
    const queryParams =
      "?auth=" + token + '&orderBy="userId"&equalTo="' + userId + '"';
    axios
      .get("/orders.json" + queryParams)
      .then((res) => {
        // tranforming obj to array
        const fetchedOrders = [];
        for (let key in res.data) {
          fetchedOrders.push({
            ...res.data[key],
            id: key,
          });
        }
        // this.setState({ loading: false, orders: fetchedOrders });
        dispatch(fetchOrdersSuccess(fetchedOrders));
      })
      .catch((err) => {
        // this.setState({ loading: false });
        dispatch(fetchOrdersFail(err));
      });
  };
};
